import { getDebugRing } from '../../lib/devUtils';
import { clx } from '../../lib/utils';

export const Heading = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={clx('mx-auto w-10/12 text-center', className, getDebugRing('blue'))}>
      <h2 className="text-lg leading-none text-black">{children}</h2>
    </div>
  );
};
